import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { coingeckoApiSolUrl } from '../utils/constants';

export const SolPriceContext = createContext<number>(0);

export function SolPriceProvder({ children }: React.PropsWithChildren<{}>) {
    const [solPriceUsd, setSolPriceUsd] = useState<number>(0);

    useEffect(() => {
        const fetchSolPrice = async () => {
            try {
                const response = await axios.get(coingeckoApiSolUrl);
                setSolPriceUsd(response.data.solana.usd);
            } catch (error) {
                console.log(`Error getting sol price: ${error}`);
            }
        };

        fetchSolPrice();

        const intervalId = setInterval(fetchSolPrice, 90000);

        return () => clearInterval(intervalId);
    }, []);

    return <SolPriceContext.Provider value={solPriceUsd}>{children}</SolPriceContext.Provider>;
}
